module.exports = __webpack_public_path__ + "static/media/ppe_saf_hel.2bfc6ff8.png";